<template>

<div :class="{'is-mobile': window.is.mobile, 'is-tablet': window.is.tablet, 'is-narrow': window.is.desktop && window.width < 1400}">

	<router-view :key="$keyPath" v-if="is.ready" />

</div>

</template>

<script>

import axios from 'axios'
import cookies from 'js-cookie'

export default {

	name: 'App',

	data: function() {
	
		return {
			is: {
				ready: false
			}
		}

	},

	created: function() {
	
		if (cookies.get(process.env.VUE_APP_COOKIE) !== undefined) {
		
			axios.defaults.headers.common['Authorization'] = cookies.get(process.env.VUE_APP_COOKIE)

			this.$api.get('session').then(function(json) {

				this.$store.commit('type', json.type)
			
				if(this.$route.name !== 'Dashboard') this.$router.push({
					name: 'Dashboard'
				})

				this.is.ready = true
			
			}.bind(this), function() {

				cookies.remove(process.env.VUE_APP_COOKIE)

				axios.defaults.headers.common['Authorization'] = null
			
				if(this.$route.name !== 'Home') this.$router.push({
					name: 'Home'
				})

				this.is.ready = true
			
			}.bind(this))
		
		} else {
		
			this.is.ready = true
		
		}
	
	}

}

</script>

<style>

</style>
